import * as React from "react";

export const NoChartData: React.FC = () => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-[24px]">
      <div className="relative">
        <div className="bg-primary h-4 w-4 rounded-full"></div>
        <div className="bg-primary absolute left-0 top-0 h-4 w-4 animate-ping rounded-full opacity-75"></div>
      </div>
      <div className="flex flex-col items-center justify-between gap-[8px]">
        <div className="text-default text-base font-semibold">
          No data found...
        </div>
        <div className="text-placeholder text-sm font-normal">
          There's not enough data to show yet. Check back later.
        </div>
      </div>
    </div>
  );
};
